/***
store data  of category and app 
***/

// import { getBackCategory} from '@/api'

export const useCatStore = defineStore(
  "catStore",
  () => {
    // 分类标题
    const title = ref("");
    // 展示弹窗
    const showCategoryModal = ref(false);
    // 当前子项 二级分类数据 Field Case Armature
    const currentSubCats = ref([]);
    // 当前分类id
    const headTitle = ref("");
    const isLoading = ref(true);
    const categoryLoadError = ref("");
    const startCategoryLoading = () => {
      categoryLoadError.value = "";
      isLoading.value = true;
    };
    const failCategoryLoading = () => {
      categoryLoadError.value = "Categories could not be loaded. Please try again.";
    };
    const finishCategoryLoading = () => {
      isLoading.value = false;
    };
    const backCategories = ref([]);
    const formatedBackCategories = ref([]);
    const formatedBackCategoriesEx = ref([]);
    const formatedBackCategoriesG2 = ref([]);

    // 当前三级数据 Bosch Delco
    const currentBrand = ref();

    // 当前四级数据 DD PLGR
    const currentSubData = ref();
    const cartNumber = ref(0);

    // 更新购物车数量
    const updateCartNumber = (num: number) => {
      cartNumber.value = num;
    };

    // 修改缓存三级数据
    const updateCurrentBrand = (data: any) => {
      currentBrand.value = data;
    };

    // 修改缓存四级数据
    const updateCurrentSubData = (data: any) => {
      currentSubData.value = data;
    };

    // 修改弹窗状态
    const changeShowCategoryModal = (isShow: boolean) => {
      // 再次展开分类弹窗，清空标签和分页缓存数据
      if (isShow) {
        localStorage.removeItem("modelIndex");
        localStorage.removeItem("page");
      }
      showCategoryModal.value = isShow;
    };

    // 修改标题
    const changeTitle = (newTitle: string) => {
      title.value = newTitle;
    };

    // 修改分类内容
    const changeCurrentSubCats = (newValue: any) => {
      currentSubCats.value = newValue;
    };

    // 修改当前分类
    const changeHeadTitle = (newValue: string) => {
      headTitle.value = newValue;
    };

    // 展示分类
    const showCategoryHandler = (newValue: any) => {
      // 修改分类id 展示高亮
      changeHeadTitle(newValue.id);
      // 展示分类弹窗
      changeShowCategoryModal(true);
      // 修改弹窗标题
      changeTitle(newValue.backCategoryName);
      // 获取分类子项
      let _backCategories: any = backCategories.value;
      for (let i in _backCategories) {
        if (_backCategories[i].id == newValue.id) {
          let __cats = _backCategories[i].children;

          // 二级分类内容排序
          __cats.sort((a: any, b: any) => a.sortNum - b.sortNum);
          changeCurrentSubCats(__cats);
          break;
        }
      }
    };

    // 首页字母排序分类栏
    const appCats = ref([
      { name: "Automotive", id: 1 },
      //  {"name":"Heavy duty","id":2}   ,
      { name: "Truck", id: 2 },
      { name: "Agriculture", id: 3 },
      //  {"name":"Ind & Con","id":4}   ,
      { name: "Construction", id: 4 },
      { name: "Forklift", id: 5 },
      { name: "Marine", id: 6 },
      { name: "Lawn & Gar", id: 7 },
      { name: "Hi-Performance", id: 8 },
      { name: "EV", id: 9 },
    ]);

    const formatCategory = () => {
      // todo: change hard code to cat_group
      const categories = [...backCategories.value];

      // asc
      categories.sort((a: any, b: any) => a.sortNum - b.sortNum);

      /// catgroup_0 : auto
      const result = categories.filter((_item: any) => {
        if (
          // _item.id != 1400511684182016 &&
          // _item.id != 1425921105608704 &&
          // _item.id != 1427768997486592
          _item.catGroup == 0
        ) {
          return true;
        } else {
          return false;
        }
      });

      // 分页数据
      formatedBackCategories.value = result;

      /// catgroup_1 : gifts
      const result2 = categories.filter((_item: any) => {
        if (_item.id == 1400511684182016 || _item.id == 1425921105608704) {
          return true;
        } else {
          return false;
        }
      });

      formatedBackCategoriesEx.value = result2;

      /// catgroup_2 : equipment
      const result3 = categories.filter((_item: any) => {
        if (_item.id == 1427768997486592) {
          return true;
        } else {
          return false;
        }
      });

      formatedBackCategoriesG2.value = result3;
    };

    // 在plugins.global中获取数据(p)并调用此方法
    const setBackCategories = (p: typeof backCategories.value) => {
      backCategories.value = p;
      formatCategory();
      categoryLoadError.value = "";
      isLoading.value = false;
      return formatedBackCategories.value;
    };

    const getBackCategories = () => {
      // if(backCategories.value==null || backCategories.value.length==0){
      //   fetchBackCategories()
      // }

      return backCategories.value;
    };

    const getAppCatName = (p: any) => {
      let _apps = appCats.value;
      for (let item in _apps) {
        if (p == (item as any)["id"]) {
          return (item as any)["name"];
        }
      }

      return "";
    };

    // const fetchBackCategories = async ()=>{
    //   let params = {
    //         level: 0,
    //         thin:true
    //   }

    //   let {result} = await getBackCategory(params)
    //   backCategories.value = result
    //   formatCategory()

    //   // getBackCategory(params).then((res) => {
    //   //   backCategories.value = res.result
    //   //   console.log("yyyyy", res.result)
    //   //   formatCategory()
    //   // })

    // }

    return {
      title,
      headTitle,
      currentSubCats,
      showCategoryModal,
      isLoading,
      categoryLoadError,
      startCategoryLoading,
      failCategoryLoading,
      finishCategoryLoading,
      backCategories,
      formatedBackCategories,
      formatedBackCategoriesEx,
      formatedBackCategoriesG2,
      setBackCategories,
      getBackCategories,
      appCats,
      getAppCatName,
      changeHeadTitle,
      changeShowCategoryModal,
      changeTitle,
      changeCurrentSubCats,
      // fetchBackCategories
      showCategoryHandler,
      cartNumber,
      updateCartNumber,
      currentBrand,
      updateCurrentBrand,
      currentSubData,
      updateCurrentSubData,
    };
  },
  {
    persist: {
      // 指定需要持久化的字段（组合式写法必须显式指定）
      // 插件 v4+ 使用 pick，v3 及以下使用 paths
      pick: ["currentBrand"],
      storage: localStorage, // 存储在 localStorage 中
    },
  },
);
